import { GetServerSidePropsContext } from 'next'

import Container from '@/components/Container/Container'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import ArticleSearch from '@/components/Wordpress/ArticleSearch/ArticleSearch'
import ArticleTypePage from '@/components/Wordpress/ArticleTypePage/ArticleTypePage'
import { getPosts } from '@/services/wordpress.service'
import { PostType } from '@/types/wordpress'
import { ARTICLES_CACHE_CONTROL } from '@/utils/constants'

export type Props = {
  author: string
  authorName: string
  pageCount: number
  pageNum: number
  posts: PostType[]
}

const ArticlesAuthorSubPage = ({ author, authorName, pageCount, pageNum, posts }: Props) => (
  <Main>
    <Container>
      <div className='mx-3'>
        <SimpleHeader className='d-flex gap-3 mb-3'>
          {authorName}
          <ArticleSearch />
        </SimpleHeader>
        <ArticleTypePage pageCount={pageCount} pageNum={pageNum} path={`author/${author}`} posts={posts} />
      </div>
    </Container>
  </Main>
)

export const getServerSideProps = async ({ params, res }: GetServerSidePropsContext) => {
  const author = params?.author as string
  let page = params?.page as string | undefined

  if (page === '1') {
    return {
      redirect: {
        destination: `/articles/author/${author}`,
        permanent: true,
      },
    }
  } else if (page === undefined) {
    page = '1'
  }

  res.setHeader('Cache-Control', ARTICLES_CACHE_CONTROL)

  // Parse the page number and redirect to parsed integer if necessary
  const pageNum = parseInt(page as string, 10)
  if (page !== `${pageNum}`) {
    return {
      redirect: {
        destination: `/articles/author/${author}/${pageNum}`,
        permanent: true,
      },
    }
  }

  try {
    const { pageCount, posts } = await getPosts({ author, category: 4, page: pageNum })
    return {
      props: {
        author,
        authorName: posts.length ? posts[0].author.name : '',
        pageCount,
        pageNum,
        posts,
      },
    }
  } catch (error) {
    console.error('Error fetching posts:', error)
    return { notFound: true }
  }
}

export default ArticlesAuthorSubPage
